export default __webpack_public_path__ + "static/media/logo-tagline.23fa4895.svg";